export const version = 'HEAD';
export const buildDate = '2026-03-20T20:59:41.412Z';
export const commitHash = '810e377';